import { categories } from "@/mocks/categories";

export default function CategoryGrid() {
  return (
    <section className="py-14 md:py-20 px-4 md:px-8 lg:px-12">
      <div className="max-w-6xl mx-auto">
        <div className="text-center mb-10 md:mb-14">
          <h2 className="font-heading text-2xl md:text-4xl font-semibold text-foreground-900 mb-3">
            Browse Product Categories
          </h2>
          <p className="text-sm md:text-base text-foreground-600 max-w-xl mx-auto">
            Explore our organized Mulebuy Spreadsheet categories. Each section contains curated products from verified China suppliers.
          </p>
        </div>

        <div className="grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-4 gap-3 md:gap-4">
          {categories.map((cat) => (
            <a
              key={cat.name}
              href={cat.url}
              target="_blank"
              rel="noopener nofollow"
              className="group relative rounded-lg overflow-hidden aspect-[3/4] cursor-pointer"
            >
              <img
                src={cat.imageUrl}
                alt={cat.name + " products in Mulebuy Spreadsheet"}
                title={cat.name + " - Mulebuy Spreadsheet Category"}
                className="w-full h-full object-cover object-top group-hover:scale-105 transition-transform duration-500"
              />
              <div className="absolute inset-0 bg-gradient-to-t from-black/70 via-black/20 to-transparent"></div>
              <div className="absolute bottom-0 left-0 right-0 p-3 md:p-4">
                <h3 className="text-background-50 font-heading text-base md:text-lg font-semibold leading-tight">
                  {cat.name}
                </h3>
                <p className="text-background-50/70 text-xs mt-1 hidden sm:block">
                  {cat.description}
                </p>
              </div>
            </a>
          ))}
        </div>
      </div>
    </section>
  );
}